module.exports = __webpack_public_path__ + "1P-Icons.0e20ad584a235801adc8.svg";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/images/fonts/1P-Icons.svg
// module id = ../../../../../src/assets/images/fonts/1P-Icons.svg
// module chunks = styles